export var grid = function grid(columns) {
  var columnWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 71;
  var columnGap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 48;
  return columnWidth * columns + columnGap * (columns - 1);
};